// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🌑 MacLookup.css — styled similar to IPInfo.css but for MAC Lookup tool */

.mac-lookup {
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  background: #111; /* Dark background */
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.7);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #f1f5f9;
}

/* Title */
.mac-lookup h3 {
  text-align: center;
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: #38bdf8;
}

/* Input & Button Group */
.mac-input-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.mac-input-group input {
  flex: 1 1;
  padding: 12px 14px;
  font-size: 1rem;
  border: 2px solid #334155;
  border-radius: 6px;
  background-color: #1e293b;
  color: #f8fafc;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.mac-input-group input:focus {
  border-color: #38bdf8;
  box-shadow: 0 0 6px rgba(56, 189, 248, 0.6);
  outline: none;
}

.mac-input-group button {
  padding: 12px 20px;
  font-size: 1rem;
  font-weight: 600;
  background-color: #0ea5e9;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mac-input-group button:hover:not(:disabled) {
  background-color: #0284c7;
}

.mac-input-group button:disabled {
  background-color: #64748b;
  cursor: not-allowed;
}

/* Error Box */
.error-box {
  background-color: #dc2626;
  color: white;
  padding: 12px 15px;
  border-radius: 6px;
  margin-top: 15px;
  font-weight: 600;
  text-align: center;
}

/* Result Box */
.result-box {
  margin-top: 20px;
  background-color: #1e293b;
  padding: 15px 20px;
  border-radius: 6px;
  border: 1px solid #334155;
  color: #f8fafc;
  text-align: center;
}

.result-box h4 {
  margin-bottom: 10px;
  color: #22c55e;
  font-size: 1.3rem;
}

.result-box p {
  font-size: 1.1rem;
  font-weight: 600;
  word-wrap: break-word;
}

/* Responsive (Mobile) */
@media (max-width: 480px) {
  .mac-lookup {
    padding: 15px;
    margin: 10px;
  }

  .mac-input-group {
    flex-direction: column;
  }

  .mac-input-group button {
    width: 100%;
  }

  .mac-input-group input {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/MacLookup.css"],"names":[],"mappings":"AAAA,4EAA4E;;AAE5E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB,EAAE,oBAAoB;EACtC,mBAAmB;EACnB,yCAAyC;EACzC,4DAA4D;EAC5D,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* 🌑 MacLookup.css — styled similar to IPInfo.css but for MAC Lookup tool */\n\n.mac-lookup {\n  max-width: 600px;\n  margin: 20px auto;\n  padding: 20px;\n  background: #111; /* Dark background */\n  border-radius: 12px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.7);\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  color: #f1f5f9;\n}\n\n/* Title */\n.mac-lookup h3 {\n  text-align: center;\n  font-size: 1.8rem;\n  margin-bottom: 20px;\n  color: #38bdf8;\n}\n\n/* Input & Button Group */\n.mac-input-group {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.mac-input-group input {\n  flex: 1;\n  padding: 12px 14px;\n  font-size: 1rem;\n  border: 2px solid #334155;\n  border-radius: 6px;\n  background-color: #1e293b;\n  color: #f8fafc;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.mac-input-group input:focus {\n  border-color: #38bdf8;\n  box-shadow: 0 0 6px rgba(56, 189, 248, 0.6);\n  outline: none;\n}\n\n.mac-input-group button {\n  padding: 12px 20px;\n  font-size: 1rem;\n  font-weight: 600;\n  background-color: #0ea5e9;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.mac-input-group button:hover:not(:disabled) {\n  background-color: #0284c7;\n}\n\n.mac-input-group button:disabled {\n  background-color: #64748b;\n  cursor: not-allowed;\n}\n\n/* Error Box */\n.error-box {\n  background-color: #dc2626;\n  color: white;\n  padding: 12px 15px;\n  border-radius: 6px;\n  margin-top: 15px;\n  font-weight: 600;\n  text-align: center;\n}\n\n/* Result Box */\n.result-box {\n  margin-top: 20px;\n  background-color: #1e293b;\n  padding: 15px 20px;\n  border-radius: 6px;\n  border: 1px solid #334155;\n  color: #f8fafc;\n  text-align: center;\n}\n\n.result-box h4 {\n  margin-bottom: 10px;\n  color: #22c55e;\n  font-size: 1.3rem;\n}\n\n.result-box p {\n  font-size: 1.1rem;\n  font-weight: 600;\n  word-wrap: break-word;\n}\n\n/* Responsive (Mobile) */\n@media (max-width: 480px) {\n  .mac-lookup {\n    padding: 15px;\n    margin: 10px;\n  }\n\n  .mac-input-group {\n    flex-direction: column;\n  }\n\n  .mac-input-group button {\n    width: 100%;\n  }\n\n  .mac-input-group input {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
